import React from 'react';

import Background from '../ui/Background';
import CallToAction from './CallToAction';
import FeaturesSection from './FeaturesSection';
import LandingFooter from '../ui/LandingFooter';
import LandingHeader from '../ui/LandingHeader';
import Testimonials from './Testimonials';
import BentoGrid from './BentoGrid';
import HeroSection from './HeroSection';

// =============================================
// Main Landing Page Component
// =============================================

const Landing: React.FC = () => {
  return (
    <Background>
      <div className="relative z-10">
        <LandingHeader />
        <HeroSection />
        <FeaturesSection />
        <BentoGrid />
        <Testimonials />
        <CallToAction />
        <LandingFooter />
      </div>
    </Background>
  );
};

export default Landing;
